module.exports = __webpack_public_path__ + "img/AFMS_JA_DT.8fbc8182.png";